import {
    UniversalLoginScaPageUniversalLoginContextFieldsV1,
    UniversalLoginScaPageUniversalLoginContextIdsV1,
    UniversalLoginScaPageUniversalLoginContextManifestV1,
    UniversalLoginScaPageVisitEventUniversalLoginFieldsV1,
    UniversalLoginScaPageVisitEventUniversalLoginIdsV1,
    UniversalLoginScaPageVisitEventUniversalLoginManifestV1,
} from '@agoda/analytics-messages-definition-universal-login/manifest/universal-login-sca-page';
import { WebAnalyticsBinder } from '@services/analytics/types';

export const ScaPageBinder: WebAnalyticsBinder = webAnalytics => {
    webAnalytics.pageContext<
        UniversalLoginScaPageUniversalLoginContextIdsV1,
        UniversalLoginScaPageUniversalLoginContextFieldsV1
    >(UniversalLoginScaPageUniversalLoginContextManifestV1.ids, {});

    webAnalytics.observe<
        UniversalLoginScaPageVisitEventUniversalLoginIdsV1,
        UniversalLoginScaPageVisitEventUniversalLoginFieldsV1
    >(UniversalLoginScaPageVisitEventUniversalLoginManifestV1.ids, {});
};
